import React from 'react';
import { Alert, Space, Typography } from 'antd';
import type { AllocationChangeResult } from '@/services/hrms.service';

const { Text } = Typography;

const AllocationResultSummary: React.FC<{ result: AllocationChangeResult }> = ({ result }) => (
  <Space direction="vertical" style={{ width: '100%' }}>
    <Text>
      {result.created} allocation(s) created, {result.ended} existing allocation(s) ended or cancelled.
    </Text>
    {result.skipped.length > 0 && (
      <Alert
        type="warning"
        showIcon
        message={`${result.skipped.length} skipped`}
        description={
          <ul style={{ margin: 0, paddingLeft: 18 }}>
            {result.skipped.map((s) => (
              <li key={`${s.employee_code}-${s.reason}`}>
                {s.employee_code}: {s.reason}
              </li>
            ))}
          </ul>
        }
      />
    )}
  </Space>
);

export default AllocationResultSummary;
